import {requestGet, requestPost, requestPut} from "../util/request";
import {ResponseProp, taskProcess, taskProcessList, TaskStatusType} from "../types/taskFlow.types";
import {PendingTask, UnreadTask} from "../types/member.type";

interface TaskResponse {
    code: number;
    data: taskProcess[];
    message: string;
}

interface TaskListResponse {
    code: number;
    data: taskProcessList[];
    message: string;
}

interface TaskUpdateResponse {
    content?: string;
    extra?: {
        checkedImgs: number[]
    }
    response?: ResponseProp;
}

export const getConversionHistory = async (conversionId?: string): Promise<taskProcess[] | null> => {
    try {
        const response = await requestGet(
            `/api/mood/detail?conversionId=${conversionId}`,
        ) as TaskResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const getActiveConversion = async (clientId?: string, boardId?: string): Promise<taskProcess[] | null> => {
    try {
        const response = await requestGet(
            `/api/mood/active?clientId=${clientId}&boardId=${boardId}`,
        ) as TaskResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const getConversionList = async (clientId?: string, boardId?: string): Promise<taskProcessList[] | null> => {
    try {
        const response = await requestGet(
            `/api/mood/list?clientId=${clientId}&boardId=${boardId}`,
        ) as TaskListResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const updateTaskStatus = async (taskId?: number, status?: TaskStatusType, clientId?: string | null): Promise<any> => {
    try {
        const response = await requestPost(
            `/api/mood/updateTaskStatus?taskId=${taskId}&status=${status}&clientId=${clientId}`,
            {}
        ) as TaskListResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const getPendingTasks = async (): Promise<{ pending: PendingTask[]; unread: UnreadTask[] } | null> => {
    try {
        const response = await requestGet(`${ process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/member/pending-tasks`, true) as {
            success: boolean;
            code: number;
            data: {
                pending: PendingTask[];
                unread: UnreadTask[];
            };
        };

        if (response?.code === 200 && response?.success) {
            return response.data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const updateTaskParams = async (taskId: number, content?: taskProcess) => {
    try {
        const response = await requestPut(
            `/api/mood/updateTaskParams?taskId=${taskId}`,
            { ...content, response: JSON.stringify(content?.response), extra: JSON.stringify(content?.extra) },
        ) as TaskListResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}